import React from "react";
import CheckboxIcon from "@/components/icons/checkbox";
import styles from "./index.module.scss";

export interface PollCheckboxProps {
  /** Option label (e.g. "Sunum Dosyaları ve Grafikler") */
  label: string;
  /** Controlled checked state */
  checked: boolean;
  /** Called when the checkbox is toggled */
  onChange: (checked: boolean) => void;
  /** Disable the option */
  disabled?: boolean;
  /** Optional name for the input (useful when grouping) */
  name?: string;
  /** Optional value for the option (e.g. for form submission) */
  value?: string;
  /** Optional id for the input (for accessibility) */
  id?: string;
  /** Optional className for the root container */
  className?: string;
}

export const PollCheckbox: React.FC<PollCheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  name,
  value,
  id,
  className,
}) => {
  const inputId = id ?? `poll-checkbox-${value ?? label.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <label
      className={`${styles.root} ${disabled ? styles.root_disabled : ""} ${className ?? ""}`}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className={styles.input}
        aria-checked={checked}
      />
      <span className={styles.boxWrap}>
        <span className={styles.box}>
          {checked && <CheckboxIcon width={14} height={14} />}
        </span>
      </span>
      <span className={styles.answer}>
        <span className={styles.label}>{label}</span>
      </span>
    </label>
  );
};

/** Question text above poll options (e.g. "2. Which materials... (You can select more than one)") */
export interface PollCheckboxQuestionProps {
  /** Main question text (can include number, e.g. "2. Eğitim sırasında...") */
  children: React.ReactNode;
  /** Optional hint in parentheses, rendered in grey */
  hint?: string;
  className?: string;
}

export const PollCheckboxQuestion: React.FC<PollCheckboxQuestionProps> = ({
  children,
  hint,
  className,
}) => (
  <div className={`${styles.question} ${className ?? ""}`}>
    {children}
    {hint != null && hint !== "" && (
      <span className={styles.questionHint}> {hint}</span>
    )}
  </div>
);

export default PollCheckbox;
